import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignIndexResponse } from '@/repositories/generated';

const content: CampaignIndexResponse[] = [
  {
    id: '1',
    publicName: '202203_ヤフオクドーム最大20%キャッシュバック',
    name: '202203_決済時2倍',
    status: 'NEW',
    approvalStatus: 'WAITING',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '2',
    publicName: '2,000円以上のお買物で最大半額当たる！スーパーマーケットジャンボ',
    name: '202203_2000円以上決済_最大半額',
    status: 'IN_PROGRESS',
    approvalStatus: 'APPROVE',
    walletServices: ['〇〇Pay', '□□Pay', '△△Pay', '☓☓Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '3',
    publicName: 'ホークス観戦は〇〇Payでバリ得！キャンペーン 〜ヤフオクドーム内の支払いで最大20%戻ってくる～',
    name: '202203_ヤフオクドーム最大20%キャッシュバック',
    status: 'WAITING',
    approvalStatus: 'APPROVE',
    walletServices: ['〇〇Pay', '□□Pay', '△△Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '4',
    publicName: 'ebookjapanゴールデンウィークは毎日最大20％戻ってくるキャンペーン',
    name: '202203_ebookjapan最大20%キャッシュバック',
    status: 'FINISH',
    shopCsvStatus: 'SUCCESS',
    approvalStatus: 'APPROVE',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '5',
    publicName: '今なら決済でポイント2倍ゲット',
    name: '202202_決済時2倍',
    status: 'IN_PROGRESS',
    approvalStatus: 'APPROVE',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '6',
    publicName: 'クレジットカード決済で最大2.5％戻ってくるキャンペーン',
    name: '202203_クレカ決済_2.5%キャッシュバック',
    status: 'NEW',
    approvalStatus: 'REJECT',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '7',
    publicName: '今なら決済でポイント2倍ゲット',
    name: '202202_決済時2倍',
    status: 'CANCEL',
    approvalStatus: 'CANCEL',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '部長 太郎',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '8',
    publicName: '今なら決済でポイント4倍ゲット',
    name: '202202_決済時4倍',
    status: 'NEW',
    approvalStatus: 'FAILURE',
    shopCsvStatus: 'UPLOAD_FAILURE',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '',
    createdAt: '2022-01-15T20:30',
  },
  {
    id: '9',
    publicName: '今なら決済でポイント10倍ゲット',
    name: '202202_決済時10倍',
    status: 'NEW',
    approvalStatus: 'FAILURE',
    shopCsvStatus: 'FAILURE',
    walletServices: ['〇〇Pay', '□□Pay'],
    startDateTime: '2022-04-18T00:00:00',
    endDateTime: '2022-04-19T00:00:00',
    createdBy: '山田 太郎',
    lastApprover: '',
    createdAt: '2022-01-15T20:30',
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const campaign = http.get(
  createMockEndpoint('/campaign'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const publicName = url.searchParams.get('publicName') ?? '';
    const name = url.searchParams.get('name') ?? '';
    const walletServiceIdExists = url.searchParams.get('walletServiceIds') ?? '';
    const shopIdExists = url.searchParams.get('shopIds') ?? '';
    const companyIdExists = url.searchParams.get('companyIds') ?? '';

    if (publicName || name || walletServiceIdExists || shopIdExists || companyIdExists) {
    // クエリパラメータあり
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 50,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 50,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 20,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
